import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangePasswordFormComponent } from './change-password-form.component';

const routes: Routes = [
    {
        path: '',
        component: ChangePasswordFormComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChangePasswordFormRoutingModule { }
